<template>
  <div id="app" class="h-100">
    <div class="d-flex flex-column h-100">
      <div class="flex-grow-1">
        <NavBar />

        <router-view />
      </div>

      <footer id="page-footer">
        <Footer />
      </footer>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default {
  components: {
    NavBar,
    Footer
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");

#app {
  font-family: "Poppins", "Sans";
}

body {
  height: 100vh;
}
</style>
